import React from 'react'
import { T } from '@transifex/react'
import { ABP_BALANCE_TYPES } from '../../../constants/abp-balance-type'
import { useAppSelector } from '../../../state/hooks'
import { selectPayAccountBalance } from '../../../state/slices/currentSale/currentSaleSlice'
import { isAccountBalancePaymentAdded } from '../../../functions/sale'
import { useFormatCurrencyValue } from './useFormatCurrencyValue'
export const AccountBalancePaymentSection = () => {
  const payAccountBalance = useAppSelector(selectPayAccountBalance)
  const formatCurrencyValue = useFormatCurrencyValue()

  if (!isAccountBalancePaymentAdded(payAccountBalance)) {
    return null
  }

  const getAbpLabel = () => {
    switch (payAccountBalance?.balanceType) {
      case ABP_BALANCE_TYPES.ON_ACCOUNT:
        return (
          <T
            _str="Account Balance Payment"
            _context="Label for account balance payment on summary panel"
          />
        )
      case ABP_BALANCE_TYPES.LAYBY:
        return (
          <T
            _str="Layaway Balance Payment"
            _context="Label for layaway balance payment on summary panel"
          />
        )
      default:
        // Legacy fallback when balanceType is absent.
        return (
          <T
            _str="Account Balance Payment"
            _context="Label for account balance payment on summary panel"
          />
        )
    }
  }

  return (
    <section className="sale-summary-section sale-summary-section-divider-top sale-summary-section-divider-btm">
      <ul className="sale-summary-list">
        <li className="sale-summary-line sale-summary-line--total">
          <div className="sale-summary-line-item sale-summary-line-item--label">
            <span className="vd-text-signpost">{getAbpLabel()}</span>
          </div>
          <div className="sale-summary-line-item sale-summary-line-item--value vd-text-intro">
            {formatCurrencyValue(payAccountBalance!.amount)}
          </div>
        </li>
      </ul>
    </section>
  )
}
